module.exports = __webpack_public_path__ + "img/curso_5_texto.d2e9afc9.png";